export default function PrivacyPolicySectionHeading({ text, index }) {
  return (
    <h2 className="font-bold text-lg mb-1">
      {index !== undefined ? `${index}. ` : ""}
      {text}
    </h2>
  );
}
